import { useState, useEffect } from "react";
import SwapVertRoundedIcon from "@mui/icons-material/SwapVertRounded";

function Table(props) {
  const { data, mapData, noDataMessage } = props;

  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    console.log("Table", data);
  }, [data]);

  // Sorting function
  const sortData = (data, sortColumn, sortOrder) => {
    return data?.sort((a, b) => {
      const valueA = a[sortColumn];
      const valueB = b[sortColumn];

      if (typeof valueA === "number" && typeof valueB === "number") {
        return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      } else {
        return sortOrder === "asc"
          ? String(valueA).localeCompare(String(valueB))
          : String(valueB).localeCompare(String(valueA));
      }
    });
  };

  const handleColumnClick = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  return (
    <>
      <div className="primeMain table-custom">
        <table width="100%" className="primeTable text-center">
          <thead
            className=""
            style={{ zIndex: "1", position: "sticky", top: "0" }}
          >
            <tr>
              {/* TODO: onSort feature */}
              {mapData?.map(({ Header, onSort }, index) => {
                return <ColumnHeader Head={Header} onSort={onSort} />;
              })}
            </tr>
          </thead>

          <tbody style={{ maxHeight: "600px", overflowY: "scroll" }}>
            {data?.length > 0 ? (
              data.map((item, index) => {
                return (
                  <tr key={index}>
                    {mapData.map(({ Cell }, celIndex) => {
                      return (
                        <td key={celIndex}>
                          <Cell row={item} index={index} />
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={mapData.length}
                  className="text-center"
                  style={{ height: "358px", borderBottom: "none" }}
                >
                  {noDataMessage || "No Data Found!"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

const ColumnHeader = ({ Head, onSort, order }) => {
  let currentOrder = order || "default"; // TODO: get current order from state
  const handleOnSortClick = () => {
    currentOrder =
      currentOrder === "default"
        ? "asc"
        : currentOrder === "asc"
          ? "desc"
          : "asc";
    onSort && onSort(currentOrder);
  };

  return (
    <th
      className={`fw-bold text-nowrap position-relative ${onSort ? "cursor pe-4" : ""}`}
      onClick={handleOnSortClick}
    >
      <div className="table-head">{Head}</div>
      {onSort && (
        <SwapVertRoundedIcon className="position-absolute end-0 top-50 translate-middle-y" />
      )}
    </th>
  );
};

export default Table;
